import { DataTableNew } from '@/design-system/data-table-new';
import { TransactionView } from '@/types/entity-types';
import { getCoreRowModel, getSortedRowModel, useReactTable } from '@tanstack/react-table';
import {
  TRANSACTION_DATE_COLUMN_ID,
  treasuryAccountTransactionsColumnDefinition,
} from './treasury-account-transactions-column-definition';

type TreasuryAccountTransactionsTableProps = {
  transactions: TransactionView[];
};

export const TreasuryAccountTransactionsTable = ({ transactions }: TreasuryAccountTransactionsTableProps) => {
  const table = useReactTable({
    data: transactions,
    columns: treasuryAccountTransactionsColumnDefinition,
    getCoreRowModel: getCoreRowModel(),
    getSortedRowModel: getSortedRowModel(),
    initialState: {
      sorting: [{ id: TRANSACTION_DATE_COLUMN_ID, desc: true }],
    },
  });

  return <DataTableNew.Table table={table} />;
};
